// extracted by mini-css-extract-plugin
export default {"bmdLabelFloating":"TextArea_bmdLabelFloating__3XWBn","errorInput":"TextArea_errorInput__NFz9w"};